import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    branchs = "branchs"
}

interface BrandLocationModel {
    fields: {
        branch: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.branchs]: BrandLocationModel[];
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    branch: state.components.contactUsForm.fieldValues["branch"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface BranchStyles {
    branchsSelect?: SelectPresentationProps;
}

export const BranchStyles: BranchStyles = {};

export const styles = BranchStyles;

const Branch: React.FC<Props> = ({ fields, branch, setFieldValue }) => {
    const { label, hintText, branchs } = fields;

    const branchChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setFieldValue({ key: "branch", value: event.target.value });
    };

    return (
        <Select
            {...styles.branchsSelect}
            label={label}
            value={branch || ""}
            onChange={branchChangeHandler}
        >
            <option value="">{hintText}</option>
            {branchs.map(branch => (
                <option key={branch.fields.branch} value={branch.fields.branch}>
                    {branch.fields.branch}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Branch),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Brand Location",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Select Brand Location",
                isRequired: true,
            },
            {
                name: fields.branchs,
                displayName: "BrandLocations",
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.branch;
                },
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "branch",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
